export function filterScreeningPallets(pallets, searchTerm) {
  return pallets.filter(p => {
    const buyOrdersSearchValue = p.buyOrders.map(o => o.toUpperCase()).join('+');
    const searchValue = [p.productName, p.invoiceId, p.vendorName, buyOrdersSearchValue].map(item => item?.toUpperCase()).join('+');
    return searchInput(searchValue, searchTerm);
  });
}

export function filterUsers(users, searchTerm) {
  return users.filter(u => {
    const searchValue = [u.firstName, u.lastName, u.username].map(item => item?.toUpperCase()).join('+');
    return searchInput(searchValue, searchTerm);
  });
}

function searchInput(searchValue, searchTerm) {
  return JSON.stringify(searchValue).toUpperCase().includes(searchTerm.toUpperCase());
}

export function filterScreeningDocuments(allDocuments, selectedFilter) {
  const documents = [...allDocuments];
  documents.forEach(p => {
    if (p.deliveryDate[p.buyOrders[0]] === null) {
      p.deliveryDate[p.buyOrders[0]] = undefined;
    }
  });

  return documents.filter(selectedFilter.filter);
}
